import { z } from "zod";

export const renvoiCompletionSchema = (t: (key: string) => string) =>
  z.object({
    motifRenvoi: z.string().nonempty(t("global.form.error.mandatoryField")),
  });
export type RenvoiCompletionFormValues = z.infer<ReturnType<typeof renvoiCompletionSchema>>;
